import React from "react";
import { Link } from "react-router-dom";

const HostSidebar = () => {
  return (
    <>
      <ul className="hostsidebar list-unstyled" id="sidebar-content">
        <li>
          <Link to="/dashboard"> Dashboard</Link>
        </li>
        <li>
          <Link to="/dashboard-profile"> Profile</Link>
        </li>
        <li>
          <Link to="/dashboard-listings"> My Listing</Link>
        </li>
        <li>
          <Link to="/dashboard-add">Add New Listing</Link>{" "}
        </li>

        <li>
          <Link to="/dashboard-reservation">Reservations</Link>{" "}
        </li>
        <li>
          <Link to="/box-request">Box Request</Link>{" "}
        </li>
        <li>
          <Link to="/dashboard-featured">Featured</Link>
        </li>
        <li data-toggle="modal" data-target="#exampleModal">
          Log out
        </li>
      </ul>
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header text-center ">
              <h5 className="modal-title ml-auto">Are you sure?</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-footer  justify-content-center">
              <button type="button" className="btn btn-primary">
                Yes
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HostSidebar;
